import { ColDef } from 'ag-grid-community';

export const PaymentHistoryColumnDef: ColDef[] = [
  {
    headerName: '#',
    width: 90,
    rowDrag: true,
    valueGetter: function (params) {
      return +params.node.id + 1;
    },
  },
  {
    // Statement Date
    headerName: 'Statement Date',
    field: 'statement_date',
    resizable: true,
    width: 150,
  },
  {
    // Subscription Type
    headerName: 'Subscription Type',
    field: 'subscription_type',
    resizable: true,
    width: 150,
    flex: 1,
  },
  {
    // Subscription Amount
    headerName: 'Subscription Amount',
    field: 'subscription_amount',
    resizable: true,
    width: 150,
  },
  {
    // View Receipt // need to finish this function
    headerName: 'View Receipt',
    valueGetter: () => 'view_receipt',
    resizable: true,
    width: 250,
    cellRenderer: (params) => {
      const link = document.createElement('a');
      link.href = '#';
      link.innerText = params.value;
      link.addEventListener('click', (event) => {
        event.preventDefault();
        alert(`View receipt for ${params.data.subscription_type}`);
        // You can replace the alert with your custom logic
      });
      return link;
    },
  },
];
